import Box from '@material-ui/core/Box';
import Alert from '@material-ui/lab/Alert';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import { ChangeEvent } from 'react';

export enum IngressOptions {
  AKS_PUBLIC = 'aks-public',
  NONE = 'none',
}

export const CreateIngress = (props: { value: IngressOptions; onChange: (value: IngressOptions) => void }) => {
  const { onChange, value, ...other } = props;
  const isExternalAccessEnabled = value === IngressOptions.AKS_PUBLIC;

  const handleIngressOptionChange = (event: ChangeEvent<HTMLInputElement>) => {
    const nextValue = event.target.checked ? IngressOptions.AKS_PUBLIC : IngressOptions.NONE;
    onChange(nextValue);
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="flex-start" mt={3} mb={3} {...other}>
      <Typography variant="h4">External Access</Typography>
      <Typography>
        Control whether this service is reachable from the internet. Default is internal-only to the cluster.
      </Typography>
      <Box mt={3}>
        <FormControlLabel
          control={<Checkbox color="primary" checked={isExternalAccessEnabled} onChange={handleIngressOptionChange} />}
          label="Enable external access (Creates a public AKS ingress)"
        />
      </Box>
      {isExternalAccessEnabled ? (
        <Box>
          <Alert severity="info" role="status">
            Apigee Microgateway is required for public access and will be enabled automatically.
            <br />
            Setup instructions will be provided after submission.
          </Alert>
        </Box>
      ) : (
        <Box mt={0.5}>
          <Typography color="textSecondary">
            Default: Internal to the cluster. Enable only if external access is required.
          </Typography>
        </Box>
      )}
    </Box>
  );
};
